import React from "react";
import styles from "./Cheptel.module.css";

function CheptelComponent() {
  return (
    <div className={styles.imageContainer}>
      <img src="/assets/images/troupeau.png" alt="Troupeau" className={styles.fullWidthImage} />
    </div>
  );
}

export default CheptelComponent;
